import { SalesIcon } from "@/components/icons/methodology/sales-icon";
import { MarketingIcon } from "@/components/icons/methodology/marketing-icon";
import { FinanceIcon } from "@/components/icons/methodology/finance-icon";
import { OperationsIcon } from "@/components/icons/methodology/operations-icon";
import { ProductIcon } from "@/components/icons/methodology/product-icon";
import { SupportIcon } from "@/components/icons/methodology/support-icon";
import { useDrawerStore } from "@/stores/drawerStore";

export function Methodology() {
  const { open: openDrawer } = useDrawerStore();

  const handleRequestChannelClick = () => {
    console.log('🎯 Opening contact drawer from methodology section');
    openDrawer();
  };

  return (
    <div className="w-full h-full text-foreground flex flex-col">
      <h3 className="font-heading text-xl mb-2">More Revenue. Less Overhead.</h3>
      <p className="font-body text-sm text-muted-foreground mb-7">
        Digital workers that run operations across your entire business
      </p>

      {/* 2x3 Grid for < 353px, 3x2 Grid for >= 353px */}
      <div className="grid grid-cols-2 [@media(min-width:353px)]:grid-cols-3 gap-4 mb-4 flex-1 content-center">
        {/* First Row */}
        <div className="flex flex-col items-center justify-center gap-2 w-full h-22 border border-border rounded-2xl hover:border-primary/40 transition-colors duration-300">
          <SalesIcon className="w-9 h-9 text-blue-500" />
          <span className="font-body text-sm text-muted-foreground font-light">Sales</span>
        </div>
        <div className="flex flex-col items-center justify-center gap-2 w-full h-22 border border-border rounded-2xl hover:border-primary/40 transition-colors duration-300">
          <MarketingIcon className="w-9 h-9 text-orange-500" />
          <span className="font-body text-sm text-muted-foreground font-light">Marketing</span>
        </div>
        <div className="flex flex-col items-center justify-center gap-2 w-full h-22 border border-border rounded-xl hover:border-primary/40 transition-colors duration-300">
          <FinanceIcon className="w-9 h-9 text-green-500" />
          <span className="font-body text-sm text-muted-foreground font-light">Finance</span>
        </div>

        {/* Second Row */}
        <div className="flex flex-col items-center justify-center gap-2 w-full h-22 border border-border rounded-2xl hover:border-primary/40 transition-colors duration-300">
          <OperationsIcon className="w-9 h-9 text-purple-500" />
          <span className="font-body text-sm text-muted-foreground font-light">Operations</span>
        </div>
        <div className="flex flex-col items-center justify-center gap-2 w-full h-22 border border-border rounded-2xl hover:border-primary/40 transition-colors duration-300">
          <ProductIcon className="w-9 h-9 text-cyan-500" />
          <span className="font-body text-sm text-muted-foreground font-light">Product</span>
        </div>
        <div className="flex flex-col items-center justify-center gap-2 w-full h-22 border border-border rounded-2xl hover:border-primary/40 transition-colors duration-300">
          <SupportIcon className="w-9 h-9 text-pink-500" />
          <span className="font-body text-sm text-muted-foreground font-light">Support</span>
        </div>
      </div>

      {/* Start Automating Button */}
      <div className="mt-4">
        <button
          onClick={handleRequestChannelClick}
          className="w-full px-6 py-2 border border-border rounded-full font-heading text-sm text-foreground hover:border-primary/40 transition-colors duration-300 cursor-pointer hover:opacity-80"
        >
          See What's Possible
        </button>
      </div>
    </div>
  );
}
